import { PureComponent } from 'react';
import shallowEqual from '../utils/shallowEqual';
// @ts-expect-error no types
import WebFont from '../vendor/webfontloader';
export default class WebFontLoader extends PureComponent {
  constructor(...args) {
    super(...args);
    this.loadFonts = () => {
      const {
        googleFontsMap
      } = this.props;
      if (!Object.keys(googleFontsMap).length) return;
      WebFont.load({
        google: {
          families: Object.keys(googleFontsMap).map(font => {
            const variants = googleFontsMap[font];
            return `${font}${variants ? `:${variants}` : ''}`;
          })
        },
        classes: false,
        events: false
      });
    };
  }
  componentDidUpdate(prevProps) {
    const {
      googleFontsMap
    } = this.props;
    const {
      googleFontsMap: prevGoogleFontsMap
    } = prevProps;
    if (!shallowEqual(googleFontsMap, prevGoogleFontsMap)) {
      this.loadFonts();
    }
  }
  render() {
    return null;
  }
}
WebFontLoader.defaultProps = {
  googleFontsMap: {}
};